import React from "react";
import "./LpServices.css";
import LpServicesHead from "./LpServicesHead";
import LpServicesMain from "./LpServicesMain";

const LpServices = () => {
  return (
    <div className="lpServices-container" id="services">
      <LpServicesHead />
      <LpServicesMain />
    </div>
  );
};

export default LpServices;
